module.exports = __webpack_public_path__ + "static/img/7.2da617e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/7.png
// module id = yzET
// module chunks = 0